import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { BandejaService } from '../../services/bandeja.service';
import { PersonaService } from '../../services/persona.service';
import { NavbarService } from '../navbar/navbar.service';
import {ArchivosNivel2AutocompleteModule} from "./archivos-nivel2-autocomplete.module";
import {ArchivoCentralService} from "../../services/archivo-central.service";

@Component({
  selector: 'app-archivos-2-autocomplete',
  templateUrl: './archivos-nivel2-autocomplete.component.html',
  styleUrls: ['./archivos-nivel2-autocomplete.component.scss']
})
export class ArchivosNivel2AutocompleteComponent implements OnInit, OnDestroy {

  @Input('control') control: FormControl

  @Input('nivel1') nivel1: string

  @Input('label') label: string

  @Input('placeholder') placeholder: string

  @Input('disable') set disable(value: boolean) {
    if (value) {
      this.inputControl.enable();
    } else {
      this.control.setValue('');
      this.inputControl.setValue('');
      this.inputControl.disable();
    }
  }

  @Output('onOptionSelected') onOptionSelected = new EventEmitter<RemitentePorArea>()

  inputControl = new FormControl('')

  options: RemitentePorArea[] = []

  optionSelected: RemitentePorArea;

  loading = false;

  optionsEmpty = false;

  private _subs = new Subscription()

  constructor(
    private _navbarService: NavbarService,
    private _bandejaService: BandejaService,
    private _archivoService: ArchivoCentralService,
  ) { }

  ngOnInit(): void {
    if (!this.nivel1) {
      this.inputControl = new FormControl({ value: '', disabled: true });
    }

    const inputSub = this.inputControl.valueChanges.pipe(debounceTime(300)).subscribe(value => {
      if (value == '') {
        this.control.setValue('')
        /*this.options = []
        return*/
      }

      this.loading = true
      this.optionsEmpty = false;
      this.options = []

      this._archivoService.getArchivoslistaNivel2({
        criterio: value, nivel1: this.nivel1
      }).then((list: any) => {
        this.options = list
        this.loading = false
        this.optionsEmpty = !Boolean(list.length)
      })
    });
    this._subs.add(inputSub)

    /*const controlSub = this.control.valueChanges.subscribe(value => {
      if (!value) this.inputControl.setValue('');
    });
    this._subs.add(controlSub)*/
  }

  ngOnDestroy(){
    this._subs.unsubscribe()
  }

  setOptionSelected(event) {
    this.optionSelected = event.option.value

    this.onOptionSelected.emit(this.optionSelected)

    const label = event.option.value

    this.inputControl.setValue(label)
    this.control.setValue(label)

  }

  onFocus() {
    this.options = []
    this.optionsEmpty = false;

    this.inputControl.setValue('')
  }

  cleanControl() {
    this.inputControl.setValue('')
    this.control.setValue('')
  }
}

export interface RemitentePorArea {
  cargo: string
  idPersona: number
  nombresCompletos: string
  username: string
  usernamePadre: string
  label?: string
}
